import React from "react";

import ChartPanel from "../chartPanel/chartPanel.component";
import { StyledPalette } from "./chartPalette.style";

const ChartPalette = () => {
  return (
    <StyledPalette>
      <div>
        <ChartPanel chartType="weekly_signups" />
      </div>
      <div>
        <ChartPanel chartType="cumulative_creations" />
      </div>
      <div>
        <ChartPanel chartType="daily_creations" />
      </div>
    </StyledPalette>
  );
};

export default ChartPalette;
